import { useMemo } from 'react';
import { extractTags, addTagToField, normalizeTags } from '../utils/tags';

function SocialMonitoring({
  projectActors,
  socialSignals,
  guardarSignal,
  newSignal,
  setNewSignal
}) {
  const suggestedTags = useMemo(() => extractTags(socialSignals), [socialSignals]);

  const agregarTag = (tag) => {
    setNewSignal({ ...newSignal, tags: addTagToField(newSignal.tags, tag) });
  };

  // Cuando se selecciona un actor, hereda su contexto territorial
  const seleccionarActor = (nombreActor) => {
    const actor = projectActors.find(a => a.nombre === nombreActor);

    if (actor) {
      setNewSignal({
        ...newSignal,
        actor: nombreActor,
        latitud: actor.latitud || newSignal.latitud,
        longitud: actor.longitud || newSignal.longitud,
        ubicacion: actor.sector
          ? `${actor.sector}, ${actor.comuna || ''}`
          : actor.comuna || newSignal.ubicacion,
        tags: newSignal.tags
          ? newSignal.tags
          : actor.tags || ''
      });
    } else {
      setNewSignal({ ...newSignal, actor: nombreActor });
    }
  };

  const actorSeleccionado = projectActors.find(a => a.nombre === newSignal.actor);

  return (
    <div>
      <div style={styles.header}>
        <h1 style={styles.title}>Señales Territoriales</h1>
        <p style={styles.subtitle}>
          Registro e interpretación de señales territoriales relevantes
        </p>
      </div>

      <div style={styles.formCard}>
        <h2 style={{ marginTop: 0 }}>Nueva señal territorial</h2>

        {/* ACTOR — primero, es lo más importante */}
        <div style={styles.actorBox}>
          <div style={styles.actorLabel}>Actor territorial vinculado</div>
          <select
            style={styles.actorSelect}
            value={newSignal.actor || ''}
            onChange={(e) => seleccionarActor(e.target.value)}
          >
            <option value="">Selecciona el actor al que pertenece esta señal</option>
            {projectActors.map((actor) => (
              <option key={actor.id} value={actor.nombre}>
                {actor.nombre}
              </option>
            ))}
          </select>

          {actorSeleccionado && (
            <div style={styles.actorPreview}>
              <span style={styles.actorPreviewName}>{actorSeleccionado.nombre}</span>
              <span style={styles.actorPreviewMeta}>
                {actorSeleccionado.sector} · {actorSeleccionado.comuna} ·
                Riesgo {actorSeleccionado.riesgo} · Influencia {actorSeleccionado.influencia}
              </span>
              <span style={styles.actorPreviewNota}>
                ✓ Coordenadas y ubicación heredadas automáticamente
              </span>
            </div>
          )}
        </div>

        {/* CAMPOS DE LA SEÑAL */}
        <div style={styles.grid}>
          <select
            style={styles.input}
            value={newSignal.red || ''}
            onChange={(e) => setNewSignal({ ...newSignal, red: e.target.value })}
          >
            <option value="">Fuente / canal</option>
            <option value="Facebook">Facebook</option>
            <option value="Instagram">Instagram</option>
            <option value="TikTok">TikTok</option>
            <option value="X / Twitter">X / Twitter</option>
            <option value="YouTube">YouTube</option>
            <option value="WhatsApp">WhatsApp</option>
            <option value="Medio digital">Medio digital</option>
            <option value="Radio">Radio</option>
            <option value="TV">TV</option>
            <option value="Declaración pública">Declaración pública</option>
            <option value="Reunión territorial">Reunión territorial</option>
            <option value="Terreno">Terreno</option>
            <option value="Nota de prensa">Nota de prensa</option>
            <option value="Acta / minuta">Acta / minuta</option>
          </select>

          <select
            style={styles.input}
            value={newSignal.sentimiento || ''}
            onChange={(e) => setNewSignal({ ...newSignal, sentimiento: e.target.value })}
          >
            <option value="">Sentimiento</option>
            <option value="Positivo">Positivo</option>
            <option value="Neutral">Neutral</option>
            <option value="Negativo">Negativo</option>
            <option value="Crítico">Crítico</option>
          </select>

          <select
            style={styles.input}
            value={newSignal.riesgo || ''}
            onChange={(e) => setNewSignal({ ...newSignal, riesgo: e.target.value })}
          >
            <option value="">Nivel de riesgo</option>
            <option value="Bajo">Bajo</option>
            <option value="Medio">Medio</option>
            <option value="Alto">Alto</option>
            <option value="Crítico">Crítico</option>
          </select>

          <select
            style={styles.input}
            value={newSignal.impacto || ''}
            onChange={(e) => setNewSignal({ ...newSignal, impacto: e.target.value })}
          >
            <option value="">Impacto territorial</option>
            <option value="Local">Local</option>
            <option value="Comunal">Comunal</option>
            <option value="Provincial">Provincial</option>
            <option value="Regional">Regional</option>
            <option value="Nacional">Nacional</option>
          </select>

          <select
            style={styles.input}
            value={newSignal.tipo || ''}
            onChange={(e) => setNewSignal({ ...newSignal, tipo: e.target.value })}
          >
            <option value="">Tipo de señal</option>
            <option value="Conflicto">Conflicto</option>
            <option value="Apoyo">Apoyo</option>
            <option value="Desinformación">Desinformación</option>
            <option value="Movilización">Movilización</option>
            <option value="Denuncia">Denuncia</option>
            <option value="Medios">Medios</option>
          </select>

          <input
            type="date"
            style={styles.input}
            value={newSignal.fecha || ''}
            onChange={(e) => setNewSignal({ ...newSignal, fecha: e.target.value })}
          />

          <input
            style={styles.input}
            placeholder="Link publicación"
            value={newSignal.link || ''}
            onChange={(e) => setNewSignal({ ...newSignal, link: e.target.value })}
          />

          <input
            style={styles.input}
            placeholder="Etiquetas (separadas por coma)"
            value={newSignal.tags || ''}
            onChange={(e) => setNewSignal({ ...newSignal, tags: e.target.value })}
          />
        </div>

        {suggestedTags.length > 0 && (
          <div style={styles.suggestedBox}>
            <div style={styles.suggestedTitle}>Etiquetas sugeridas</div>
            <div style={styles.tagsBox}>
              {suggestedTags.map((tag) => (
                <button
                  key={tag}
                  style={styles.suggestedTag}
                  onClick={() => agregarTag(tag)}
                >
                  #{tag}
                </button>
              ))}
            </div>
          </div>
        )}

        <textarea
          style={styles.textarea}
          rows="4"
          placeholder="Descripción de la señal — qué se dijo, quién, en qué contexto..."
          value={newSignal.texto || ''}
          onChange={(e) => setNewSignal({ ...newSignal, texto: e.target.value })}
        />

        {/* Coordenadas ocultas — se llenan automáticamente desde el actor */}
        <div style={styles.coordsInfo}>
          {actorSeleccionado && (newSignal.latitud || newSignal.longitud) ? (
            <span style={{ color: '#12b76a' }}>
              ✓ Coordenadas: {newSignal.latitud}, {newSignal.longitud}
            </span>
          ) : (
            <span style={{ color: '#98a2b3' }}>
              Selecciona un actor para heredar coordenadas automáticamente
            </span>
          )}
        </div>

        <button style={styles.button} onClick={guardarSignal}>
          Guardar señal
        </button>
      </div>

      {/* LISTA DE SEÑALES */}
      <div style={styles.tableCard}>
        <h2 style={{ marginTop: 0 }}>Señales detectadas</h2>

        {socialSignals.length === 0 && (
          <p style={{ color: '#667085' }}>Sin señales registradas.</p>
        )}

        {socialSignals
          .slice()
          .reverse()
          .map((signal) => (
            <div
              key={signal.id}
              style={{
                ...styles.signalCard,
                borderLeft:
                  signal.sentimiento === 'Crítico' ? '6px solid #d92d20' :
                  signal.sentimiento === 'Negativo' ? '6px solid #f79009' :
                  signal.sentimiento === 'Positivo' ? '6px solid #12b76a' :
                  '6px solid #667085'
              }}
            >
              <div style={styles.signalTop}>
                <div>
                  <strong>{signal.red}</strong> · {signal.tipo}
                </div>
                <div style={styles.badge}>{signal.sentimiento}</div>
              </div>

              {signal.actor && (
                <div style={styles.actorTag}>
                  → {signal.actor}
                </div>
              )}

              <div style={styles.meta}>
                Riesgo: {signal.riesgo} · Impacto: {signal.impacto} · {signal.fecha}
              </div>

              {signal.ubicacion && (
                <div style={styles.meta}>📍 {signal.ubicacion}</div>
              )}

              {signal.tags && (
                <div style={styles.tagsBox}>
                  {normalizeTags(signal.tags).map((tag, index) => (
                    <span key={index} style={styles.tag}>#{tag}</span>
                  ))}
                </div>
              )}

              <p style={styles.text}>{signal.texto}</p>

              {signal.link && (
                <a href={signal.link} target="_blank" rel="noreferrer">
                  Ver publicación →
                </a>
              )}
            </div>
          ))}
      </div>
    </div>
  );
}

const styles = {
  header: { marginBottom: '30px' },
  title: {
    margin: 0,
    fontSize: '34px',
    color: 'white'
  },
  subtitle: { color: '#98a2b3' },
  formCard: {
    background: 'white',
    padding: '30px',
    borderRadius: '14px',
    marginBottom: '30px',
    boxShadow: '0 8px 25px rgba(0,0,0,0.06)'
  },
  actorBox: {
    background: '#f0fdf4',
    border: '1px solid #bbf7d0',
    borderRadius: '12px',
    padding: '18px',
    marginBottom: '20px'
  },
  actorLabel: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#166534',
    marginBottom: '10px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  actorSelect: {
    width: '100%',
    padding: '14px',
    borderRadius: '10px',
    border: '1px solid #86efac',
    fontSize: '15px',
    background: 'white'
  },
  actorPreview: {
    marginTop: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  actorPreviewName: {
    fontWeight: 'bold',
    color: '#166534',
    fontSize: '15px'
  },
  actorPreviewMeta: {
    color: '#667085',
    fontSize: '13px'
  },
  actorPreviewNota: {
    color: '#12b76a',
    fontSize: '12px',
    fontWeight: 'bold'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '14px',
    marginBottom: '20px'
  },
  input: {
    padding: '14px',
    borderRadius: '10px',
    border: '1px solid #d0d5dd',
    fontSize: '14px'
  },
  suggestedBox: {
    background: '#f8fafc',
    border: '1px solid #e4e7ec',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '20px'
  },
  suggestedTitle: { fontWeight: 'bold', marginBottom: '12px' },
  textarea: {
    width: '100%',
    padding: '16px',
    borderRadius: '10px',
    border: '1px solid #d0d5dd',
    marginBottom: '12px',
    boxSizing: 'border-box',
    fontSize: '14px',
    lineHeight: '1.5'
  },
  coordsInfo: {
    fontSize: '12px',
    marginBottom: '16px'
  },
  button: {
    background: '#1f8f5f',
    color: 'white',
    border: 'none',
    padding: '14px 22px',
    borderRadius: '10px',
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  tableCard: {
    background: 'white',
    padding: '30px',
    borderRadius: '14px',
    boxShadow: '0 8px 25px rgba(0,0,0,0.06)'
  },
  signalCard: {
    background: '#f9fafb',
    padding: '18px',
    borderRadius: '12px',
    marginBottom: '16px'
  },
  signalTop: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px'
  },
  badge: {
    background: '#101828',
    color: 'white',
    padding: '4px 10px',
    borderRadius: '8px',
    fontSize: '13px'
  },
  actorTag: {
    color: '#1f8f5f',
    fontWeight: 'bold',
    fontSize: '13px',
    marginBottom: '8px'
  },
  meta: {
    color: '#667085',
    marginBottom: '6px',
    fontSize: '14px'
  },
  tagsBox: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginBottom: '10px'
  },
  tag: {
    background: '#eef4ff',
    color: '#1849a9',
    padding: '5px 10px',
    borderRadius: '999px',
    fontSize: '12px',
    fontWeight: 'bold'
  },
  suggestedTag: {
    background: '#e0f2fe',
    color: '#075985',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '999px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 'bold'
  },
  text: { lineHeight: '1.6', margin: 0 }
};

export default SocialMonitoring;